module.exports = __webpack_public_path__ + "img/ezc-wt-habanero-animation.6806d980.gif";